import Api from "../../../util/Api";

export default function getInitState() {
    return {
        doctorFormIsOpen: false,
        doctorGridIsOpen: true,
        doctorDataTableOptions: {
            server_mode: true,
            global_search: {
                visibility: false,
            }
        },
        doctorActions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új doktor',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newDoctorRow'
            }
        ],
        doctorRowActions: [
            {
                btn_text: '<i class="fas fa-book-medical"></i>',
                title: 'Szakvizsgák',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'showExamGrid',
                additionalButtonVisible: "hasRoleEditBackofficeEditSalary"
            }, 
            {
                btn_text: '<i class="fas fa-language"></i>',
                title: 'Beszélt nyelvek',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'showLanguageGrid',
                additionalButtonVisible: "hasRoleEditBackofficeEditSalary"
            }, 
            {
                btn_text: '<i class="fas fa-money-bill-wave"></i>',
                title: 'Díjazás',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'showFeeTable',
            }, 
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyDoctorRow',
                additionalButtonVisible: "hasRoleEditBackofficeEditSalary"
            }, 
            {
                btn_text: '<i class="fas fa-copy"></i>',
                title: 'Másolás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'copyDoctorRow',
                additionalButtonVisible: "hasRoleEditBackofficeEditSalary"
            }, 
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteDoctorRow',
                additionalButtonVisible: "hasRoleEditBackofficeEditSalary"
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteDoctorRow',
                additionalButtonVisible: "hasRoleEditBackofficeEditSalaryForUndelete"
            }
        ],
        doctorHeaderFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false,
                formVisible: false,
            },
            {
                name: "registrationNumber",
                label: "Nyilvántartási szám",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'text',
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "identityCardNumber",
                label: "Személyi igazolvány szám",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "title",
                label: "Titulus",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formVisible: true
            },
            {
                name: "lastName",
                label: "Vezetéknév",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "firstName",
                label: "Keresztnév",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "nationality",
                label: "Állampolgárság",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "placeOfBirth",
                label: "Születési hely",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "dateOfBirth",
                label: "Születési dátum",
                visibility: false,
                formType: 'date',
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "motherName",
                label: "Anyja neve",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "birthFirstName",
                label: "Születési keresztnév",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formVisible: true
            },
            {
                name: "birthLastName",
                label: "Születési vezetéknév",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formVisible: true
            },
            {
                name: "sex",
                label: "Neme",
                visibility: false,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getSexOptions,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "fullName",
                label: "Név",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
                formVisible: false
            },
            {
                name: "stampNo",
                label: "Orvosi pecsétszám",
                visibility: false,
                formRequired: true,
                formType: 'text',
                formSize: 2,
                formVisible: true
            },
            {
                name: "email",
                label: "E-mail cím",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formVisible: true
            },
            {
                name: "phoneNumber",
                label: "Telefonszám",
                visibility: false,
                formType: 'tel',
                formSize: 2,
                formVisible: true
            },

            {
                name: "user",
                label: "Felhasználó",
                visibility: false,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getFreeDoctorUsers,
                    formatText: function (val) {
                        return val.username;
                    },
                    formatOption: function (val) {
                        return val.username;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'username',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 2,
                formVisible: true
            },
            {
                name: "isRetired",
                label: "Nyugdíjas",
                visibility: false,
                formType: 'select',
                selectOptions: {
                    externalOptionList: [{id: '0', text: 'Nem'}, {id: '1', text: 'Igen'}],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "isSzakdolgozo",
                label: "Szakdolgozó",
                description: "Az adott orvos szakdolgozó-e",
                formType: 'checkbox',
                formSize: 2,
                visibility: false,
                formVisible: true
            },
            {
                name: "createdBy",
                label: "createdBy",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "createdOn",
                label: "createdOn",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'date',
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'date',
            },
            {
                name: "deleted",
                label: "deleted",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'number',
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],

        examFormIsOpen: false,
        examGridIsOpen: true,
        examActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class ",
                event_payload: 'backToGridFromExamGrid'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új szakvizsga',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newExamRow'
            }
        ],
        examFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToExamGrid'
            }, {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetExamForm'
            }
        ],
        examRowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyExamRow'
            }, {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteExamRow',
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteExamRow'
            }
        ],
        examHeaderFields: [
            {
                name: "id",
                label: "id",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'number',
            },
            {
                name: "humanResourceId",
                label: "humanResourceId",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'number',
            },
            {
                name: "szakvkodId",
                label: "Szakvizsga kód (PUPHA)",
                visibility: false,
                formVisible: true,
                formType: "select",
                formRequired: true,
                formSize: 3,
                selectOptions: {
                    apiCallback: Api.getExamSzakvkod,
                    formatText: function (val) {
                        return val.leiras;
                    },
                    formatOption: function (val) {
                        return val.leiras;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'leiras',
                    returnValue: 'idSzakvkodok',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "exam",
                label: "Szakképzés megnevezése",
                sort: true,
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'text',
                formSize: 3,
                formVisible: true
            },
            {
                name: "examNumber",
                label: "Szakképzés száma (szám/év)",
                sort: true,
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'text',
                formSize: 2,
                formVisible: true
            },
            {
                name: "issuingInstitution",
                label: "Kiállító intézmény",
                sort: true,
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'text',
                formSize: 4,
                formVisible: true
            },
            {
                name: "placeOfIssue",
                label: "Kiállítási hely",
                sort: true,
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'text',
                formSize: 2,
                formVisible: true
            },
            {
                name: "dateOfIssue",
                label: "Kiállítás ideje",
                sort: true,
                filter: {
                    type: "simple",
                },
                slot_name: "date_format",
                visibility: true,
                formType: 'date',
                formSize: 2,
                formVisible: true
            },
            {
                name: "examLanguage",
                label: "Képzés nyelve",
                sort: true,
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'text',
                formSize: 3,
                formVisible: true
            },
            {
                name: "localizationNumber",
                label: "Honosítási határozat száma",
                visibility: false,
                formType: 'number',
                formSize: 2,
                formVisible: true
            },
            {
                name: "recognizingLocalizationInstitution",
                label: "Honosító/Elismerő intézmény",
                visibility: false,
                formType: 'text',
                formSize: 3,
                formVisible: true
            },
            {
                name: "placeOfLocalizationIssue",
                label: "Honosítás helye",
                visibility: false,
                formType: 'text',
                formSize: 2,
                formVisible: true
            },
            {
                name: "dateOfLocalizationIssue",
                label: "Honosítás ideje",
                visibility: false,
                formType: 'date',
                formSize: 2,
                formVisible: true
            },
            {
                name: "companyId",
                label: "companyId",
                visibility: false,
                formVisible: false
            },
            {
                name: "employeeType",
                label: "employeeType",
                visibility: false,
                formVisible: false
            },
            {
                name: "deleted",
                label: "deleted",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                visibility: false,
                formVisible: false
            },
            {
                name: "createdBy",
                label: "createdBy",
                visibility: false,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "createdOn",
                visibility: false,
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],

        languageFormIsOpen: false,
        languageGridIsOpen: false,
        languageActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class",
                event_payload: 'backToDoctorGrid'
            }, 
            {
                btn_text: '<i class="fas fa-plus"></i> Új nyelv',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newLanguageRow'
            }
        ],
        languageFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToLanguageGrid'
            }, 
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetLanguageForm'
            }
        ],
        languageRowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyLanguageRow'
            }, {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteLanguageRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteLanguageRow'
            }
        ],
        languageHeaderFields: [
            {
                name: "id",
                label: "id",
                visibility: false,
            },
            {
                name: "humanResourceId",
                label: "humanResourceId",
                visibility: false,
            },
            {
                name: "language",
                label: "Nyelv",
                sort: true,
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'text',
                formSize: 4,
                formRequired: true,
                formVisible: true
            },
            {
                name: "inWritingId",
                label: "Írásban",
                visibility: false,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getLanguageMark,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 4,
                formRequired: true,
                formVisible: true
            },
            {
                name: "inWriting.text",
                label: "Írásban",
                visibility: true,
            },
            {
                name: "orallyId",
                label: "Szóban",
                visibility: false,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getLanguageMark,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 4,
                formRequired: true,
                formVisible: true
            },
            {
                name: "orally.text",
                label: "Szóban",
                visibility: true,
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                visibility: false,
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                visibility: false,
            },
            {
                name: "createdBy",
                label: "createdBy",
                visibility: false,
            },
            {
                name: "createdOn",
                label: "createdOn",
                visibility: false,
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
            }
        ],

        feeFormIsOpen: false,
        feeGridIsOpen: false,
        feeActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új díjazás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newFeeRow'
            }
        ],
    }
}
